import { UserAgentApplication} from 'msal';
import {Account} from "msal/src/Account";

export type DataObject = {
    isAuthenticated: boolean,
    accessToken: string,
    user: object,
    graph: object,
    custom: object
}

export type Request = {
    scopes?: string[]
}

export default class AuthService {
    private tokenExpirationTimer: undefined | number = undefined;
    public data: DataObject = {
        isAuthenticated: false,
        accessToken: '',
        user: {},
        graph: {},
        custom: {}
    };

    private storage = "sessionStorage";

    private auth: any = {
        authority: "https://login.microsoftonline.com/0ca0882f-c8bc-470c-9558-49fdaa447587",
        clientId: '09f6bab6-6b08-4323-aa85-08a43a18f9db',
        validateAuthority: true,
        redirectUri: window.location.origin,
        navigateToLoginRequestUrl: true
    };

    private readonly request: Request = {
        scopes: ["user.read"]
    };

    private isIE(): boolean {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf("MSIE ") > -1;
        const msie11 = ua.indexOf("Trident/") > -1;
        const isEdge = ua.indexOf("Edge/") > -1;

        return msie || msie11 || isEdge;
    }

    private applicationConfig: any = {
        auth: this.auth,
        cache: {
            cacheLocation: this.storage,
            storeAuthStateInCookie: this.isIE()
        }
    };

    private app: UserAgentApplication;

    constructor() {
        this.app = new UserAgentApplication(this.applicationConfig);

        this.app.handleRedirectCallback((error) => {
            if (error) {
                const errorMessage = error.errorMessage ? error.errorMessage : "Unable to acquire access token.";
                console.log(errorMessage);
            }
        });
    }

    public isAuthenticated(): boolean {
        return !this.app.isCallback(window.location.hash) && !!this.app.getAccount();
    }

    public login(): any {
        if (!this.app.isCallback(window.location.hash)) {
            this.app.loginRedirect();
        }
    }

    public logout(): void {
        this.app.logout();
    }

    public async acquireToken(request = this.request): Promise<String> {
        try {
            const response = await this.app.acquireTokenSilent(request);
            if(this.data.accessToken !== response.accessToken) {
                this.setAccessToken(response.accessToken, response.expiresOn, response.scopes);
            }
            return response.idToken.rawIdToken;
        } catch(error) {
            this.app.acquireTokenRedirect(request);
        }
    }

    public getAccount(): Account {
        if (this.app.getAccount()) {
            return this.app.getAccount();
        } else {
            return;
        }
    }

    private setAccessToken(accessToken: string, expiresOn: Date, scopes: string[]) {
        this.data.accessToken = accessToken;
        const expirationOffset = 300 * 1000;
        const expiration = expiresOn.getTime() - (new Date()).getTime() - expirationOffset;
        if (this.tokenExpirationTimer) clearTimeout(this.tokenExpirationTimer);
        this.tokenExpirationTimer = window.setTimeout(() => {
            this.acquireToken();
        }, expiration)
    }
}
